import { render, staticRenderFns } from "./Nap.vue?vue&type=template&id=4954ab07&scoped=true&"
import script from "./Nap.vue?vue&type=script&lang=js&"
export * from "./Nap.vue?vue&type=script&lang=js&"
import style0 from "./Nap.vue?vue&type=style&index=0&id=4954ab07&lang=scss&scoped=true&"
import style1 from "./Nap.vue?vue&type=style&index=1&id=4954ab07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4954ab07",
  null
  
)

export default component.exports